import { useCarDistanceLimitUnitQuery } from '../services/carService/__generated__/queries.generated';
import { asDistanceUnit, DistanceUnit } from '../utils/units';

/**
 * Spec 028: the unit a car's own distance limits are stored in (miles until
 * known). Read with `no-cache`, so the partial `distanceLimit` never replaces
 * the full one in the Apollo cache.
 */
export function useCarDistanceUnit(carId: string | null | undefined): {
  unit: DistanceUnit;
  /** Spec 028 D11: the unit of the car's odometer reading (`mileage`); miles until known. */
  odometerUnit: DistanceUnit;
  loaded: boolean;
} {
  const { data, loading } = useCarDistanceLimitUnitQuery({
    variables: { id: carId ?? '' },
    skip: !carId,
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  });
  return {
    unit: asDistanceUnit(data?.car?.distanceLimit?.unit),
    odometerUnit: asDistanceUnit(data?.car?.odometerUnit),
    loaded: !loading,
  };
}
